import React from "react";
import { Redirect, Route } from "react-router-dom";
import auth from "../providers/Auth.Provider";

const SecuredRoute = ({ component: Component, ...rest }) => (
	<Route
		{...rest}
		render={props =>
			auth.authProvider.isLoggedIn ? (
				<Component {...props} />
			) : (
				<Redirect
					to={{
						pathname: "/login",
						state: { from: props.location },
						search: `?redirect=${props.location.pathname}`
					}}
				/>
			)
		}
	/>
);

export default SecuredRoute;
